/**
 * Build-time settings. The CI build has no Google key, so a missing key is a
 * state the app reports (`NOT_CONFIGURED`), not a crash.
 */

/** Where the ERP that embeds this app is served. */
const PRODUCTION_HOST_ORIGINS: readonly string[] = ['https://app.bonbon-erp.com'];

/** The ERP's dev server and the desktop app's dev server. */
const DEVELOPMENT_HOST_ORIGINS: readonly string[] = [
  'http://localhost:5173',
  'http://localhost:5174',
];

export const ALLOWED_HOST_ORIGINS: readonly string[] = import.meta.env.DEV
  ? [...PRODUCTION_HOST_ORIGINS, ...DEVELOPMENT_HOST_ORIGINS]
  : PRODUCTION_HOST_ORIGINS;

export interface GoogleMapsConfig {
  apiKey: string;
  mapId: string;
}

/**
 * Google's demo Map ID: vector maps and advanced markers work with it, but
 * without cloud styling. For a local run with only a dev key.
 */
const DEMO_MAP_ID = 'DEMO_MAP_ID';

export function readGoogleMapsConfig(
  env: Pick<ImportMetaEnv, 'VITE_GOOGLE_MAPS_API_KEY' | 'VITE_GOOGLE_MAPS_MAP_ID'> & {
    DEV: boolean;
  } = import.meta.env,
): GoogleMapsConfig | null {
  const apiKey = env.VITE_GOOGLE_MAPS_API_KEY?.trim() ?? '';
  const configuredMapId = env.VITE_GOOGLE_MAPS_MAP_ID?.trim() ?? '';
  const mapId = configuredMapId !== '' ? configuredMapId : env.DEV ? DEMO_MAP_ID : '';
  return apiKey === '' || mapId === '' ? null : { apiKey, mapId };
}
